'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var MetricsContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  margin: 1rem 0;\n"], ["\n  display: flex;\n  margin: 1rem 0;\n"])));
var BarContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  margin: 1rem 0;\n"], ["\n  margin: 1rem 0;\n"])));
var MetricContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  flex-basis: 33%;\n"], ["\n  flex-basis: 33%;\n"])));
var Score = styled__default.p(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  color: #4c506c;\n  font-family: ", ";\n  font-size: 2.1rem;\n  font-weight: 600;\n  margin: 1.5rem 0 0.3rem 0;\n"], ["\n  color: #4c506c;\n  font-family: ", ";\n  font-size: 2.1rem;\n  font-weight: 600;\n  margin: 1.5rem 0 0.3rem 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.fontFamily;
});
var ScoreTitle = styled__default.p(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin: 0.3rem 0 1rem 0;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin: 0.3rem 0 1rem 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.text.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.fontFamily;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.BarContainer = BarContainer;
exports.MetricContainer = MetricContainer;
exports.MetricsContainer = MetricsContainer;
exports.Score = Score;
exports.ScoreTitle = ScoreTitle;
